import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlyFieldProps } from '@ngx-formly/primeng/form-field';
import { RadioButton } from 'primeng/radiobutton';
import { FORM_IMPORTS } from '../../_shared/_imports/form.import';

export interface RadioButtonFieldProps extends FormlyFieldProps {}

@Component({
  selector: 'radio-field',
  standalone: true,
  imports: [...FORM_IMPORTS, RadioButton],
  template: `
    <div class="flex gap-2">
      @for (option of $any(props.options); track option) {
        <div class="p-field-radiobutton flex gap-2">
          <div>{{ option.label }}</div>
          <p-radioButton
            [name]="field.name || id"
            [formControl]="option.disabled ? disabledControl : formControl"
            [value]="option.value"
          >
          </p-radioButton>
        </div>
      }
    </div>
  `,
})
export class RadioFieldType extends FieldType<
  FieldTypeConfig<RadioButtonFieldProps>
> {
  get disabledControl() {
    return new FormControl({ value: this.formControl.value, disabled: true });
  }
}
